import { ACTIONS_SHIFT } from '../_constants/shift.constants';

const initialState = {
  byId: {},
};

export function shiftReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_SHIFT.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_SHIFT.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_SHIFT.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default shiftReducer;
